export default {
  page: function () {
    this.loadTransfers()
  }
}
